import { MAIN_HEADER_HEIGHT, SIDEBAR_WIDTH } from '@/catalog-apps/components/config'
import { Button } from '@/components/shadcn/button'
import { IconCopyOutline } from '@icons/IconCopyOutline'
import { IconRefreshOutline } from '@icons/IconRefreshOutline'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { IconMinusOutline } from '@icons/IconMinusOutline'
import { motion } from 'motion/react'
import { useAppPageLayout } from '../../useAppPageLayout'
import { getPageHeights } from '@/catalog-apps/components/component-library/utils/getPageHeights'
import { useGetAppPage } from '../../useGetAppPage'

type GridLayoutInfoDisplayProps = {
  cols: number
  rows: number
}

export function GridLayoutInfoDisplay({ cols, rows }: GridLayoutInfoDisplayProps) {
  const {
    data: { emphasizeHeader },
  } = useGetAppPage()
  const { handleResetPageLayout, copyJsonLayout, addColumn, removeColumn, addRow, removeRow } = useAppPageLayout()
  const { headerHeight } = getPageHeights(emphasizeHeader ?? false)
  return (
    <motion.div
      style={{ top: MAIN_HEADER_HEIGHT + headerHeight - 20, left: SIDEBAR_WIDTH - 20 }}
      className="fixed z-20 w-max overflow-hidden rounded bg-background shadow-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.3 }}
    >
      <div className="flex flex-col bg-secondary/30">
        <div className="p-2.5 text-base font-semibold">Grid Layout:</div>
        <div className="grid grid-cols-[1fr_min-content_min-content_min-content] items-center gap-x-3 p-2.5 pt-0 leading-tight">
          <span>Grid columns:</span>
          <span className="tabular-nums">{cols}</span>
          <Button variant="outline" size="icon" className="h-6 w-6" onClick={removeColumn}>
            <IconMinusOutline className="h-3.5 w-3.5" />
          </Button>
          <Button variant="outline" size="icon" className="h-6 w-6" onClick={addColumn}>
            <IconPlusOutline className="h-3.5 w-3.5" />
          </Button>

          <span>Grid rows:</span>
          <span className="tabular-nums">{rows}</span>
          <Button variant="outline" size="icon" className="h-6 w-6" onClick={removeRow}>
            <IconMinusOutline className="h-3.5 w-3.5" />
          </Button>
          <Button variant="outline" size="icon" className="h-6 w-6" onClick={addRow}>
            <IconPlusOutline className="h-3.5 w-3.5" />
          </Button>
        </div>
        <div className="flex flex-col gap-y-2.5 p-2.5">
          <Button className="h-7 text-xs" size="sm" onClick={handleResetPageLayout}>
            <IconRefreshOutline className="mr-1 h-4 w-4" />
            Reset to default
          </Button>
          <Button variant="outline" className="h-7 text-xs" size="sm" onClick={() => copyJsonLayout('json')}>
            <IconCopyOutline className="mr-1 h-4 w-4" />
            Copy JSON
          </Button>
          <Button variant="outline" className="h-7 text-xs" size="sm" onClick={() => copyJsonLayout('py')}>
            <IconCopyOutline className="mr-1 h-4 w-4" />
            Copy Python
          </Button>
        </div>
      </div>
    </motion.div>
  )
}
